// Color swatch functionality for product cards
document.addEventListener('DOMContentLoaded', function() {
  // Handle color swatch clicks
  document.querySelectorAll('.color-swatch__item').forEach(swatch => {
    swatch.addEventListener('mouseover', function() {
      const variantImage = this.getAttribute('data-variant-image');
      if (variantImage) {
        const card = this.closest('.card-wrapper');
        const productImage = card.querySelector('.card__media img');
        
        // Store original image to revert back when mouse leaves
        if (!productImage.hasAttribute('data-original-src')) {
          productImage.setAttribute('data-original-src', productImage.src);
        }
        
        // Change image to variant image
        productImage.src = variantImage;
      }
    });
    
    swatch.addEventListener('mouseout', function() {
      const card = this.closest('.card-wrapper');
      const productImage = card.querySelector('.card__media img');
      
      // Revert to original image
      if (productImage.hasAttribute('data-original-src')) {
        productImage.src = productImage.getAttribute('data-original-src');
      }
    });
  });
});